<template>
  <div class="container" id="container">
    <!-- <div class="top-banner">
      <div class="banner-img">
        <img class="banner" src="../../../assets/images/jobs/banner.png" alt="">
      </div>
    </div> -->

    <div class="main-page">
      <!-- 列表 -->
      <div class="job-list">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          :error-text="errorText"
          loading-text="加载中..."
          :finished-text="finishedText"
          @load="onGetMore"
        >
          <div class="my-sign" v-for="item in jobList" :key="item.id">
            <p style="width: 100%; font-weight: bold">
              职位名称：{{ item.job_title }}
            </p>
            <p>姓名：{{ item.realname }}</p>
            <p>电话：{{ item.mobile }}</p>
            <p>
              状态：<span style="color: #e95944; font-weight: bold">{{
                item.item_show_status
              }}</span>
              <span
                v-if="item.item_show_msg"
                style="
                  color: #e95944;
                  font-weight: bold;
                  font-size: 11px;
                  display: block;
                "
                >{{ item.item_show_msg }}</span
              >
            </p>
            <p v-if="item.need_pay == 1">
              报名费支付状态：<span style="color: #e95944; font-weight: bold">{{
                item.pay_status == 0
                  ? "未支付"
                  : item.pay_status == 2
                  ? "已退款"
                  : "已支付"
              }}</span>
            </p>
            <p v-if="item.need_pay2 == 1">
              考试培训费考试培训费支付状态：<span
                style="color: #e95944; font-weight: bold"
                >{{
                  item.pay_status2 == 0
                    ? "未支付"
                    : item.pay_status2 == 2
                    ? "已退款"
                    : "已支付"
                }}</span
              >
            </p>
            <p v-if="item.status_msg">反馈意见：{{ item.status_msg }}</p>
            <div class="btn-box">
              <a
                class="btn confirm btn-download"
                v-if="item.item_show_operation == 'edit'"
                href="javascript:;"
                @click="editSign(item)"
                >修改</a
              >
              <a
                class="btn confirm btn-download"
                v-if="
                  item.need_pay == 1 &&
                  (item.pay_status == 0 || item.pay_status == 2)
                "
                href="javascript:;"
                @click="goPay(item)"
                >缴报名费</a
              >
              <a
                class="btn confirm btn-download"
                v-if="
                  item.need_pay2 == 1 &&
                  item.status == 1 &&
                  (item.pay_status2 == 0 || item.pay_status2 == 2)
                "
                href="javascript:;"
                @click="showPayfinal(item)"
                >缴考试培训费</a
              >
              <a
                class="btn confirm btn-download"
                v-if="item.item_show_operation == 'interview'"
                href="javascript:;"
                @click="toReservation(item)"
                >预约</a
              >
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <!-- 缴费弹框 -->
    <van-dialog
      v-model="dialogVisible"
      title="缴费通知"
      show-cancel-button
      class="mbBOx"
      confirmButtonText="同意"
      cancelButtonText="不同意"
      @confirm="goPayfinal"
      @cancel="dialogVisible = false"
    >
      <div class="dialogBox">
        <p>2026年沙特中文教师考试培训费缴纳及考试安排通</p>
        <p class="p2">
          2026年沙特中文教师考试培训费缴纳通道已开启，请资料审核合格的报名人员按需登录系统缴费。
        </p>
        <p class="pblod">一、缴费人员及截止时间</p>
        <p class="p2">1.缴费人群：资料审核已合格人员</p>
        <p class="p2">2.选拔考试安排原则：按缴费顺序，优先满足选定考试时间</p>
        <p class="p2">3.缴费截止时间：北京时间2026年5月28日15:00</p>
        <p class="pblod">二、考试安排</p>
        <p class="p2">1.《国际中文教师证书》专场考试</p>
        <p class="p2">2026年沙特中文教师招募《国际中文教师证书》笔试（初级）专场考试定于：</p>
        <p class="p4">(1)考试时间：北京时间2026年6月6日，14:00-15:40</p>
        <p class="p4">(2)报名截止时间：北京时间2026年5月28日 15:00</p>
        <p class="p4">(3)考试形式：线上</p>
        <p class="p4">(4)需参考人员：没有笔试成绩、未持有证书或笔试成绩、证书已超出有效期的报名人员，需参加考试。请注意，《国际中文教师证书》是入职沙特的必要条件。</p>
        <p class="p4">(5)证书申请：已持有笔试成绩并在有效期内入职的老师，以及通过专场考试笔试成绩合格并顺利入职的老师，均可免于面试，直接申请《国际中文教师证书》。证书申请服务费标准为220元/人（邮寄仅限国内收件地区，国外收件地区的邮寄费用将根据实际收件地另行核算），该费用在申请证书时线上缴纳即可。</p>
        <p class="p2">2.选拔考试及心理测试</p>
        <p class="p4">(1)时间：2026年6月13日-14日（周末两天，每人考试时间为一个半天）</p>
        <p class="p4">(2)形式：线上</p>
        <p class="p4">(3)选拔考试时间选择统计将于缴费结束后通知，请关注报名时填写邮箱及面试群通知。</p>
        <p class="pblod">三、退费政策</p>
        <p class="p2">1.不可退费情况：缴费后弃考或缺席考试，费用不予退还。</p>
        <p class="p2">2.可退费情况：未入选入职名单的人员，将在入职名单确定后全额退费。</p>
        <p class="p2">3.退费时间：入职名单确定后30个工作日内完成退费（具体到账时间以银行为准）。</p>
        <p class="p2">4.重要提醒：</p>
        <p class="p4">(1)缴费后即锁定考位，请谨慎确认是否参加。</p>
        <p class="p4">(2)退费仅适用于选拔考试后未入选入职者，弃考者不退费。</p>
        <p class="p4">(3)我公司将保留最终解释权。</p>
        <p class="pblod">四、咨询方式</p>
        <p class="p2">1.微信群加入流程</p>
        <p class="p4">(1)成功缴纳报名费后，您将在2个工作日内通过报名提交邮箱收到面试群二维码。</p>
        <p class="p4">(2)请注意查收邮箱，并及时扫码入群。</p>
        <p class="p2">2.未收到通知的处理方式，如遇以下情况：</p>
        <p class="p4">(1)缴费超过2个工作日未收到群二维码。</p>
        <p class="p4">(2)二维码过期无法入群。请联系：官方邮箱：recruit@wuzhouchinese.com（邮件请注明：ID号+姓名+缴费凭证）</p>
        <p class="p2">3.重要提醒</p>
        <p class="p4">(1)咨询群是获取考试通知的重要渠道，请及时加入。</p>
        <p class="p4">(2)入群后请按照申请姓名修改群昵称。</p>
        <p class="p4">(3)群内禁止发布与招募无关的信息。</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "JobList",

  data() {
    return {
      errorText: "网络开小差了，点击重新加载",
      jobList: [],
      searchInput: "",
      searchKeyword: "",
      // 工作地点
      locationOptions: [],
      workTypeOptions: [],
      locationSelected: "",
      positionSelected: "",
      jobPopupVisible: false,
      listPage: 0,
      loading: false,
      finished: false,
      error: false,

      dialogVisible: false,
      nowpayfinal: {},
    };
  },
  computed: {
    ...mapState("dic", ["workTypeList"]),
    // 职位类型
    showEmpty() {
      return !this.error && !this.loading && this.jobList.length === 0;
    },
    finishedText() {
      return this.jobList.length === 0 ? "" : "— 到底咯！—";
    },
    isMobile() {
      return document.body.clientWidth < 992;
    },
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler: function (newPath, oldPath) {
        if (newPath !== oldPath) {
          const container = document.getElementById("container");
          if (container) {
            container.scrollTop = 0;
          }
          this.refreshJobList();
        }
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    editSign(item) {
      this.$router.push({
        name: "Resume",
        query: {
          id: item.id,
          job_id: item.job_id,
        },
      });
    },
    toReservation(item) {
      this.$router.push({
        name: "MineApplicationReservation",
        query: {
          job_id: item.job_id,
        },
      });
    },

    goDetail(event) {
      this.$router.push({
        name: "EventDetail",
        query: {
          event_id: event.id,
        },
      });
    },

    // 重新获取职位列表
    refreshJobList() {
      // 清空列表数据
      this.jobList = [];
      this.finished = false;
      this.listPage = 0;
      this.getJobList();
    },

    // 获取更多数据
    onGetMore() {
      // 分页更新
      this.listPage += 1;
      this.getJobList();
    },

    // 获取一页数据
    getJobList() {
      this.loading = true;

      const params = {
        offset: this.listPage,
        limit: 10,
      };

      this.$api
        .GET_MYSIGN_LIST(params)
        .then((res) => {
          this.jobList = this.jobList.concat(res);
          this.finished = true;
          this.error = false;
        })
        .catch(() => {
          this.error = true;
          this.listPage -= 1;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goPay(item) {
      this.$router.push({
        name: "Pay",
        query: {
          job_id: item.job_id,
        },
      });
    },
    showPayfinal(item) {
      this.nowpayfinal = item;
      this.dialogVisible = true;
    },
    goPayfinal() {
      this.$router.push({
        name: "Payfinal",
        query: {
          job_id: this.nowpayfinal.job_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 50px);
  overflow-y: scroll;
  background: white;
  padding-bottom: 75px;
}

.top-banner {
  .banner-video {
    width: 100%;
    z-index: 10;
    overflow: hidden;

    .video {
      overflow: hidden;
      // border-radius: 15px 15px 0 0;
    }
  }

  .banner-img img {
    width: 100%;
  }
}

.job-list {
  padding-bottom: 25px;
  padding-top: 25px;

  .event-cover {
    display: block;
    width: calc(100% - 40px);
    margin: 0 20px;
  }

  ::v-deep .van-empty__image {
    width: 216px;
  }

  ::v-deep .van-empty__image img {
    width: 216px;
    height: 150px;
  }

  ::v-deep .van-empty__bottom {
    color: #999999;
    font-size: 14px;
  }

  ::v-deep .van-list__finished-text {
    color: #cccccc;
  }
}

.job-steps {
  text-align: left;

  .van-step--finish {
    color: #e95944;
  }

  .job-steps-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      margin-right: 15px;
      color: #1989fa;
    }
  }

  h3 {
    font-size: 18px;
    margin: 5px 0;
  }

  p {
    font-size: 14px;
    margin: 5px 0;
  }
}

::v-deep .van-step--vertical {
  padding: 0 0 0 8px !important;
  line-height: 2 !important;

  .van-steps__items {
    padding: 10px 0;
  }

  .van-step__circle-container {
    top: 15px;
    left: -15px;
  }

  .van-step__circle {
    width: 8px;
    height: 8px;
  }

  .van-step__icon {
    font-size: 14px;
  }
}

.company-info {
  padding: 15px 19px;

  .top {
    display: flex;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .name {
      position: relative;
      margin: 0;
      font-size: 18px;
      font-weight: bold;
      padding-left: 8px;

      &::before {
        display: block;
        content: "";
        width: 3px;
        height: 18px;
        background: #e95944;
        position: absolute;
        top: 4px;
        left: 0;
      }
    }

    span {
      display: flex;
      line-height: 24px;
    }
  }

  .title-more {
    display: flex;
    align-items: center;
    color: #333;
  }
}

::v-deep .van-popup__close-icon--top-right {
  top: 24px;
}

.btn {
  height: 38px;
  width: 100px;
  margin: 5px 20px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  border: 1px solid #eaedf0;
  background: linear-gradient(90deg, #e95944 0%, #e95944 100%);
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.confirm {
  color: #ffffff;
}

.job-result {
  .btn {
    margin: 0 auto;
    cursor: pointer;
  }
}

.detail-join {
  .btn {
    margin: 10px auto;
    cursor: pointer;
  }
}

::v-deep {
  .notice-list {
    .van-cell__title {
      text-align: left;
      font-size: 14px;
    }
  }
}

.my-sign {
  margin: 0 20px;
  display: flex;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  background: #f3f3f3;
  border-radius: 20px;
  font-size: 15px;
  position: relative;
  margin-bottom: 10px;

  p {
    margin: 0 5px;
    width: 100%;
    text-align: left;
    margin-bottom: 5px;
  }

  .btn-box {
    display: flex;
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .btn {
    width: 80px;
    height: 30px;
    margin: 0;
  }
}

.detail-join-fixed {
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0px;
  left: 0px;
  text-align: center !important;
  z-index: 999;
  margin-bottom: 0 !important;
}

.btn-download {
  width: 120px;
  height: 40px;
  margin-top: 15px;
  color: #e95944;
  background: #ddd;
}

@media (min-width: 992px) {
  .container {
    height: 100%;
    padding-bottom: 75px;
    overflow-y: auto;
  }

  .main-page {
    max-width: 900px;
    margin: 0 auto;
  }

  .top-banner {
    .banner-video {
      width: 100%;
    }

    .banner-img img {
      width: 100%;
    }
  }

  .job-list {
    padding-bottom: 25px;
    padding-top: 25px;

    .event-cover {
      display: block;
      width: 200px;
      padding-left: 20px;
      margin: 0;
    }

    ::v-deep .van-empty__image {
      width: 216px;
    }

    ::v-deep .van-empty__image img {
      width: 216px;
      height: 150px;
    }

    ::v-deep .van-empty__bottom {
      color: #999999;
      font-size: 14px;
    }
  }

  .company-info {
    padding: 15px 19px;

    .title {
      .name {
        margin: 0;
        font-size: 18px;
        padding-left: 8px;

        &::before {
          display: block;
          content: "";
          width: 3px;
          height: 18px;
          top: 4px;
          left: 0;
        }
      }

      span {
        line-height: 24px;
      }
    }
  }

  ::v-deep .van-popup__close-icon--top-right {
    top: 24px;
  }

  .btn {
    height: 36px;
    width: 100px;
    font-size: 16px;
    border-radius: 25px;
    border: 1px solid #eaedf0;
    cursor: pointer;
  }

  .confirm {
    color: #ffffff;
    margin-left: auto;
  }

  .job-result {
    .btn {
      margin: 0 auto;
      cursor: pointer;
    }
  }

  .detail-join {
    .btn {
      margin: 10px auto;
      cursor: pointer;
    }
  }

  ::v-deep {
    .notice-list {
      .van-cell__title {
        text-align: left;
        font-size: 14px !important;
        padding-left: 10px;
      }
    }
  }

  .my-sign {
    margin: 0 20px;
    display: flex;
    align-items: center;
    padding: 10px;
    flex-wrap: wrap;
    background: #f3f3f3;
    border-radius: 20px;
    font-size: 15px;
    position: relative;
    margin-bottom: 10px;

    p {
      width: 30%;
      margin: 0 5px;
      text-align: left;
      margin-bottom: 5px;
    }

    p:last-child {
      min-width: 100%;
    }

    .btn-box {
      display: flex;
      position: absolute;
      top: 5px;
      right: 5px;
    }

    .btn {
      width: 80px;
      height: 30px;
      margin: 0;
    }
  }

  .detail-join-fixed {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0px;
    left: 0px;
    text-align: center !important;
    z-index: 999;
    margin-bottom: 0 !important;
  }
}
</style>

<style scoped lang="scss">
.job-detail {
  padding-top: 15px;
}

.top-info {
  padding: 0 20px;
  display: block;
  justify-content: normal;
  text-align: left;

  p {
    margin-right: 10px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 33px;
    margin-right: 20px;
    text-align: left;
    padding-bottom: 0.5em;
  }

  .go-detail {
    width: 60px;
    min-width: 60px;
    margin-right: 30px;
    transform: translateY(1.5px);
    text-decoration: underline;
    color: #e95944;
    font-size: 12px;
    margin-top: 7px;
  }
}

.labels {
  margin: 0px 20px;
  padding-bottom: 10px;
  display: flex;
  height: 20px;
  align-items: center;

  .label {
    font-size: 14px;
    color: #666666;
    display: flex;
    align-items: center;

    .icon-label {
      width: 15px;
      height: 15px;
      margin-right: 6px;
    }

    span {
      height: 20px;
      line-height: 20px;
    }

    span.work-city {
      max-width: 75px;
    }
  }

  .event-label {
    display: block;
  }

  .bar {
    width: 1px;
    height: 15px;
    margin: 0 10px;
    background: #f1f4f6;
  }
}

.scroll-div {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .release-time {
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    margin-bottom: 14px;
  }

  .card-info {
    padding: 6px 15px;
    background: #f8fafb;
    border-radius: 10px;
    margin-bottom: 25px;

    .van-col {
      padding: 5px;
      display: flex;
      align-items: center;
      font-size: 14px;

      .info-label {
        color: #999999;
      }

      .info-value {
        margin-left: 10px;
        font-weight: bold;
        color: #333333;
        max-width: 70px;
      }
    }
  }

  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 0px;
    padding-top: 15px;
  }

  .detail {
    width: 100%;
    font-size: 15px;
    color: #666666;
    word-wrap: break-word;
    word-break: normal;
    white-space: pre-wrap;
    text-align: left;
    max-width: 100%;
    line-height: 28px;
    margin-bottom: 0px;

    p {
      margin: 0;
    }
  }
}

::v-deep .van-loading {
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.popup {
  overflow: hidden;

  .scroll-div {
    height: 354px;
    max-height: 48vh;
    overflow-y: scroll;
  }
}

::v-deep .detail p {
  margin-top: 10px;
  margin-bottom: 0;
}

.mbBOx {
  top: 50%;
}
.dialogBox {
  text-align: left;
  height: 65vh;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    padding-bottom: 5px;
  }
  .p2 {
    // text-indent: 28px;
    padding-left: 28px;
  }
  .p4 {
    // text-indent: 56px;
    padding-left: 56px;
  }
  .pb {
    padding-bottom: 5px;
  }
  .pblod {
    font-weight: 600;
  }
}

@media (min-width: 992px) {
  .job-steps {
    text-align: left;

    .van-step--finish {
      color: #e95944;
    }

    .job-steps-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      a {
        margin-right: 15px;
        color: #1989fa;
      }
    }

    h3 {
      font-size: 18px;
      margin: 5px 0;
    }

    p {
      font-size: 14px;
      margin: 5px 0;
    }
  }

  ::v-deep .van-steps--vertical {
    padding: 0 0 0 40px !important;
  }

  ::v-deep .van-step--vertical {
    padding: 0 0 0 10px !important;
    line-height: 2 !important;
    font-size: 14px;

    .van-steps__items {
      padding: 10px 0;
    }

    .van-step__circle-container {
      top: 14px !important;
      left: -15px !important;
    }

    .van-step__line {
      left: -15px !important;
      top: 20px !important;
    }

    .van-step__circle {
      width: 8px;
      height: 8px;
    }

    .van-step__icon {
      font-size: 14px;
    }
  }

  .job-detail {
    padding-top: 15px;
    border-bottom: 1px solid #efefef;
    display: flex;
    // align-items: center;
    // justify-content: space-between;
  }

  .top-info {
    padding: 0 20px;
    align-self: flex-start;
    display: flex;
    justify-content: normal;

    p {
      margin-right: 10px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 33px;
      margin-right: 20px;
      text-align: left;
    }

    .go-detail {
      width: 60px;
      min-width: 60px;
      margin-right: 30px;
      transform: translateY(1.5px);
      text-decoration: underline;
      color: #e95944;
      font-size: 12px;
      margin-top: 7px;
    }
  }

  .labels {
    margin: 0px 20px;
    padding-bottom: 10px;
    display: flex;
    height: 20px;
    align-items: center;
    position: absolute;
    bottom: 0;

    .label {
      font-size: 14px;
      color: #666666;
      display: flex;
      align-items: center;

      .icon-label {
        width: 15px;
        height: 15px;
        margin-right: 6px;
      }

      span {
        height: 20px;
        line-height: 20px;
      }

      span.work-city {
        max-width: 75px;
      }
    }

    .event-label {
      display: block;
    }

    .bar {
      width: 1px;
      height: 15px;
      margin: 0 10px;
      background: #f1f4f6;
    }
  }

  .scroll-div {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .release-time {
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      margin-bottom: 14px;
    }

    .card-info {
      padding: 6px 15px;
      background: #f8fafb;
      border-radius: 10px;
      margin-bottom: 25px;

      .van-col {
        padding: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;

        .info-label {
          color: #999999;
        }

        .info-value {
          margin-left: 10px;
          font-weight: bold;
          color: #333333;
          max-width: 70px;
        }
      }
    }

    .sub-title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0px;
      padding-top: 15px;
    }

    .detail {
      font-size: 15px;
      color: #666666;
      word-wrap: break-word;
      word-break: normal;
      white-space: pre-wrap;
      text-align: left;
      max-width: 100%;
      line-height: 28px;
      margin-bottom: 0px;

      p {
        margin: 0;
      }
    }
  }

  ::v-deep .van-loading {
    width: 100%;
    height: 100%;
    background: white;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .popup {
    overflow: hidden;

    .scroll-div {
      height: 354px;
      max-height: 48vh;
      overflow-y: scroll;
    }
  }

  ::v-deep .detail p {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .btn-download {
    width: 120px;
    height: 40px;
    margin-top: 15px;
    color: #e95944;
    background: #ddd;
  }

  .mbBOx {
    width: 700px;
    ::v-deep .van-dialog__header {
      padding-top: 10px;
      line-height: 40px;
    }
    .dialogBox {
      text-align: left;
      height: 65vh;
      overflow: auto;
      padding: 20px;
      box-sizing: border-box;
      p {
        margin: 0;
        padding: 0;
        font-size: 14px;
        padding-bottom: 5px;
      }
      .p2 {
        // text-indent: 28px;
        padding-left: 28px;
      }
      .p4 {
        // text-indent: 56px;
        padding-left: 56px;
      }
      .pb {
        padding-bottom: 5px;
      }
      .pblod {
        font-weight: 600;
      }
    }
  }
}
</style>
